import React from 'react'
import { Popover, Typography } from '@mui/material'

const fontFamilyType = 'var(--font-family)'

const PopoverCustom = ({ id, open, anchorEl, onClose, text }) => (
  <Popover
    id={id}
    sx={{ pointerEvents: 'none' }}
    open={open}
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: 'center',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 32,
      horizontal: 'center',
    }}
    onClose={onClose}
    disableRestoreFocus>
    <Typography
      sx={{
        p: 0,
        px: '4px',
        fontFamily: fontFamilyType,
        fontSize: 11,
      }}>
      {text}
    </Typography>
  </Popover>
)
export default PopoverCustom
